import { CustomNumberPipe } from '@agilox/pipe/custom-number';
import { DropdownModule } from '@agilox/ui';
import { Component, computed, inject, input, model } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { resetCountdown } from '../reset-countdown.util';

const INTEGER_DIGIT_INFO = '1.0-0';
const PERCENT_SUFFIX = ' %';
const FULL_PERCENT = 100;
const RING_RADIUS = 6;
const RING_STROKE = 2;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
// Open inverts onto the green fill, so the ring is drawn in white instead of grey.
const TRACK_COLOR_CLOSED = 'var(--color-secondary-200)';
const TRACK_COLOR_OPEN = 'rgb(255 255 255 / 0.4)';
const RING_COLOR_CLOSED = 'var(--color-secondary-600)';
const RING_COLOR_OPEN = 'var(--color-white)';
const UNIT_KEY_PREFIX = 'ai_chat.usage_limit.unit_';

@Component({
	selector: 'ai-chat-usage-limit',
	templateUrl: './ai-chat-usage-limit.component.html',
	imports: [CustomNumberPipe, DropdownModule, TranslatePipe],
	host: { class: 'block w-full' },
})
export class AiChatUsageLimitComponent {
	private translate = inject(TranslateService);

	percentUsed = input<number>(0);
	resetAt = input<number | null>(null);
	windowDays = input<number>(0);

	open = model<boolean>(false);

	barPercent = computed(() => Math.min(FULL_PERCENT, Math.max(0, this.percentUsed())));

	ringOffset = computed(() => RING_CIRCUMFERENCE * (1 - this.barPercent() / FULL_PERCENT));

	resetLabel = computed(() => {
		const resetAt = this.resetAt();
		if (resetAt === null) return '';

		const { days, hours, minutes } = resetCountdown(resetAt, this.now);
		const parts = [
			...(days > 0 ? [`${days}${this.unit('day')}`] : []),
			...(days > 0 || hours > 0 ? [`${hours}${this.unit('hour')}`] : []),
			`${minutes}${this.unit('minute')}`,
		];
		return parts.join(' ');
	});

	protected integerDigitInfo = INTEGER_DIGIT_INFO;
	protected percentSuffix = PERCENT_SUFFIX;
	protected ringRadius = RING_RADIUS;
	protected ringStroke = RING_STROKE;
	protected ringCircumference = RING_CIRCUMFERENCE;
	protected trackColorClosed = TRACK_COLOR_CLOSED;
	protected trackColorOpen = TRACK_COLOR_OPEN;
	protected ringColorClosed = RING_COLOR_CLOSED;
	protected ringColorOpen = RING_COLOR_OPEN;

	private now = Date.now();

	private unit(name: string): string {
		return this.translate.instant(`${UNIT_KEY_PREFIX}${name}`);
	}
}
